import { get, put } from '@/lib/api/client'
import {
  type Procurement,
  type ProcurementDetail,
  type ApiResponse,
} from '@/lib/api/types'

export class ProcurementService {
  /**
   * GET procurements (Public endpoint)
   */
  async getProcurements(): Promise<ApiResponse<Procurement[]>> {
    return await get<ApiResponse<Procurement[]>>(
      `documents/public/all`
    )
  }

  /**
   * Get procurement by ID (Public endpoint)
   * GET /documents/public/{procurementId}
   */
  async getProcurementById(procurementId: string): Promise<ApiResponse<ProcurementDetail>> {
    return await get<ApiResponse<ProcurementDetail>>(
      `documents/public/${procurementId}`
    )
  }

  /**
   * Increment view count for a procurement
   * PUT /documents/public/{procurementId}/increment-view
   */
  async incrementView(procurementId: string): Promise<ApiResponse<void>> {
    return await put<ApiResponse<void>>(
      `documents/public/${procurementId}/increment-view`
    )
  }

  /**
   * Increment download count for a procurement
   * PUT /documents/public/{procurementId}/increment-download
   */
  async incrementDownload(procurementId: string): Promise<ApiResponse<void>> {
    return await put<ApiResponse<void>>(
      `documents/public/${procurementId}/increment-download`
    )
  }

  /**
   * Get home page highlights
   * GET /documents/public/highlights?type=HOME_PAGE_KEY_RESOURCES
   */
  async getHomePageHighlights(): Promise<ApiResponse<Procurement[]>> {
    return await get<ApiResponse<Procurement[]>>(
      'documents/public/highlights?type=HOME_PAGE_KEY_RESOURCES'
    )
  }
}

// Export singleton instance
export const procurementService = new ProcurementService()

// Export default
export default procurementService

